import * as XLSX from 'xlsx';

export function CommonExcel(filteredData, filterText, report_title, report_sheet_title, report_excel_name) {

    // const dataArray = Object.values(data);

    // const filteredData = dataArray
    //     .filter(item => item !== null)
    //     .map((item, index) => ({
    //         "Sr. No": (index + 1).toString(),
    //         "ID Code": item.code_generate,
    //         "Teacher Name": item.full_name,
    //         "Teacher Email": item.email,
    //         "Earnings in USD": '$' + item.earnings,
    //         "Earnings in CAD": '$' + item.earnings_cad,
    //     }));

    // filteredData

    const workbook = XLSX.utils.book_new();

    // ✅ Create worksheet with empty origin (we'll control row positions)
    const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });

    // =========================
    // 1️⃣ Add Custom Header Rows
    // =========================

    // let filterText = "";

    // if (selectedPeriod === "yearly") {
    //     filterText = `Yearly : ${startYear} - ${endYear}`;
    // } else if (selectedPeriod === "monthly") {
    //     filterText = `Monthly : ${startMonth} - ${endMonth}`;
    // } else {
    //     filterText = `${selectedPeriod.toUpperCase()} : ${startDate} - ${endDate}`;
    // }

    // filterText

    let headerRows = [[report_title]];

    if (filterText && filterText.trim() !== "") {
        headerRows.push([filterText]);
    }

    headerRows.push([]); // empty row before table

    // XLSX.utils.sheet_add_aoa(worksheet, [
    //     // ["Top 25 Teachers Generating the Most Income"],
    //     [report_title],
    //     [filterText],
    //     [] // empty row
    // ], { origin: "A1" });

    XLSX.utils.sheet_add_aoa(worksheet, headerRows, { origin: "A1" });

    // =========================
    // 2️⃣ Add Table Data from Row 4
    // =========================

    // XLSX.utils.sheet_add_json(worksheet, filteredData, {
    //     origin: "A4",
    //     skipHeader: false
    // });

    const tableStartRow = headerRows.length + 1;

    XLSX.utils.sheet_add_json(worksheet, filteredData, {
        origin: `A${tableStartRow}`,
        skipHeader: false
    });

    // =========================
    // 3️⃣ Merge Title Across Columns
    // =========================

    worksheet["!merges"] = [
        {
            s: { r: 0, c: 0 },
            e: { r: 0, c: 5 } // merge till last column (adjust if columns increase)
        },
        {
            s: { r: 1, c: 0 },
            e: { r: 1, c: 5 }
        }
    ];

    if (filterText && filterText.trim() !== "") {
        worksheet["!merges"].push({
            s: { r: 1, c: 0 },
            e: { r: 1, c: 5 }
        });
    }

    // =========================
    // 4️⃣ Add AutoFilter (Important: start from header row 4)
    // =========================

    const totalRows = filteredData.length + 3; // header rows + data

    worksheet['!autofilter'] = {
        ref: `A4:F${totalRows + 1}`
    };

    // XLSX.utils.book_append_sheet(workbook, worksheet, "Teacher Report");
    XLSX.utils.book_append_sheet(workbook, worksheet, report_sheet_title);

    // XLSX.writeFile(workbook, "teacher_report.xlsx");
    XLSX.writeFile(workbook, `${report_excel_name}.xlsx`);
    
}